;(function () {
  'use strict'

  var resumingForms = new WeakSet()
  var checkoutAttempt = 0
  var checkoutPending = false
  var checkoutRecoveryTimer = null
  var checkoutOwner = null

  function resetCheckout() {
    checkoutAttempt += 1
    checkoutPending = false
    window.clearTimeout(checkoutRecoveryTimer)
    if (window.CHICCHOK_CART_FLOW && checkoutOwner !== null) window.CHICCHOK_CART_FLOW.endCheckout(checkoutOwner)
    checkoutOwner = null
    document.querySelectorAll('button[name="checkout"][aria-busy="true"]').forEach(function (button) {
      button.removeAttribute('aria-busy')
    })
  }

  function checkoutError(error) {
    var message = error && error.message || window.themeVariables?.strings?.cartOperationError || 'Checkout could not start. Please try again.'
    var flow = window.CHICCHOK_CART_FLOW
    if (flow && typeof flow.showError === 'function') {
      flow.showError(message)
      return
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
      bubbles: true,
      cancelable: true,
      detail: { status: 'error', error: message },
    }))
  }

  function currentCartForm(id) {
    if (id) {
      var identified = document.getElementById(id)
      return identified instanceof HTMLFormElement && identified.isConnected ? identified : null
    }
    var forms = document.querySelectorAll('form.cart')
    return forms.length === 1 && forms[0].isConnected ? forms[0] : null
  }

  document.addEventListener('submit', function (event) {
    var form = event.target
    var submitter = event.submitter
    if (resumingForms.has(form)) return
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return
    var implicitCheckout = !submitter && (form.id === 'mini-cart-form' || form.id === 'main-cart-form') && form.querySelector('input[type="hidden"][name="checkout"]')
    if (!implicitCheckout && (!submitter || submitter.name !== 'checkout')) return
    event.preventDefault()
    var flow = window.CHICCHOK_CART_FLOW
    if (!flow || typeof flow.assertPurchasableCart !== 'function') {
      checkoutError(new Error(window.themeVariables && window.themeVariables.strings.cartPurchaseReadError || 'We could not check your cart. Please retry before checkout.'))
      return
    }
    if (checkoutPending || flow && !flow.beginCheckout()) return
    checkoutOwner = flow.getCheckoutAttempt()
    checkoutPending = true
    var attempt = ++checkoutAttempt
    var formId = form.id
    if (submitter) submitter.setAttribute('aria-busy', 'true')

    Promise.resolve().then(async function () {
      if (flow) await flow.waitForMutations(20000)
      try {
        if (window.CHICCHOK_OPENAI_TRACKING) await window.CHICCHOK_OPENAI_TRACKING.prepareCheckout()
      } catch (error) {}
      if (attempt !== checkoutAttempt) return
      if (window.CHICCHOK_PROTECTION_GUARD) await window.CHICCHOK_PROTECTION_GUARD.ensureConfirmed()
      if (flow) {
        var cart = await flow.refreshCart({ allowCheckoutRender: true })
        flow.assertPurchasableCart(cart)
      }
      if (attempt !== checkoutAttempt) return
      var currentForm = currentCartForm(formId)
      if (!currentForm) throw new Error(window.themeVariables?.strings?.cartOperationError || 'The cart has changed. Please try checkout again.')
      var currentSubmitter = Array.from(currentForm.elements).find(function (element) {
        return element.name === 'checkout' && element.type === 'submit' && element.form === currentForm && element.isConnected && !element.disabled
      })
      if (!currentSubmitter) throw new Error(window.themeVariables?.strings?.cartOperationError || 'The checkout button is unavailable. Please try again.')
      if (!Array.from(currentForm.elements).some(function (element) { return element.name === 'checkout' && element.type === 'hidden' && !element.disabled })) {
        var checkoutInput = document.createElement('input')
        checkoutInput.type = 'hidden'
        checkoutInput.name = 'checkout'
        currentForm.appendChild(checkoutInput)
      }
      var quantityInputs = Array.from(currentForm.elements).filter(function (element) { return element.name === 'updates[]' })
      var quantityDisabled = quantityInputs.map(function (element) { return element.disabled })
      currentSubmitter.setAttribute('aria-busy', 'true')
      resumingForms.add(currentForm)
      quantityInputs.forEach(function (element) { element.disabled = true })
      try {
        if (typeof currentForm.requestSubmit === 'function') currentForm.requestSubmit(currentSubmitter)
        else HTMLFormElement.prototype.submit.call(currentForm)
      } finally {
        quantityInputs.forEach(function (element, index) { element.disabled = quantityDisabled[index] })
        resumingForms.delete(currentForm)
      }
      checkoutRecoveryTimer = window.setTimeout(function () {
        if (attempt !== checkoutAttempt) return
        resetCheckout()
        checkoutError(new Error(window.themeVariables?.strings?.cartOperationTimeout || 'Checkout is taking longer than expected. Please try again.'))
      }, 20000)
    }).catch(function (error) {
      if (attempt !== checkoutAttempt) return
      resetCheckout()
      checkoutError(error)
    })
  }, true)

  document.addEventListener('click', function (event) {
    var link = event.target instanceof Element && event.target.closest('a[href]')
    if (!link || event.defaultPrevented || event.button !== 0) return
    var url = new URL(link.href, window.location.origin)
    if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return
    event.preventDefault()
    if (checkoutPending) return
    var flow = window.CHICCHOK_CART_FLOW
    if (!flow || typeof flow.preparePurchaseCheckout !== 'function') {
      checkoutError(new Error(window.themeVariables && window.themeVariables.strings.cartPurchaseReadError || 'We could not check your cart. Please retry before checkout.'))
      return
    }
    checkoutPending = true
    var attempt = ++checkoutAttempt
    Promise.resolve().then(async function () {
      var previousOwner = flow.getCheckoutAttempt()
      var preparation = flow.preparePurchaseCheckout({ isCurrent: function () { return attempt === checkoutAttempt } })
      if (flow.getCheckoutAttempt() !== previousOwner) checkoutOwner = flow.getCheckoutAttempt()
      await preparation
      if (attempt !== checkoutAttempt) return
      checkoutRecoveryTimer = window.setTimeout(function () {
        if (attempt !== checkoutAttempt) return
        resetCheckout()
        checkoutError(new Error(window.themeVariables?.strings?.cartOperationTimeout || 'Checkout is taking longer than expected. Please try again.'))
      }, 20000)
      window.location.assign(url.toString())
    }).catch(function (error) {
      if (attempt !== checkoutAttempt) return
      resetCheckout()
      checkoutError(error)
    })
  }, true)

  window.addEventListener('pagehide', resetCheckout)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resetCheckout()
  })
})()

